/**
 * Reset filtrů v nastavení newsletteru
 */
export default function () {
	let clearButton = document.getElementById('clear-filters-setting');
	if (clearButton === null) {
		return;
	}

	clearButton.addEventListener('click', function () {
		document
			.querySelectorAll('.filters-wrapper .filters-item .multiselect-dropdown [data-clear-single-filter]')
			.forEach(function (filterClearButton) {
				filterClearButton.dispatchEvent(new Event('click'));
			});
	});
}
